import React from "react";
import CrossCloseButton from "./parts/CrossCloseButton";

export default function () {
  return (
    <div className="modal modal_480 modal-supply">
      <div className="modal-supply__close">
        <CrossCloseButton className="custom-cross-btn_black" />
      </div>
      <h2 className="modal-supply__title">Confirm Supply</h2>
      <div className="modal-supply__controls">
        <button className="custom-button">
          <span>Confirm</span>
        </button>
        <button className="modal-supply__cancel">Cancel</button>
      </div>
    </div>
  );
}
